module.exports = __webpack_public_path__ + "img/product-program-switch-yszc.932ac996.png";